import { dollars } from '@nuts/auto-delivery-sdk/dist/utils/money';
import pick from 'lodash/pick';

import { NutsLineItem } from '@/lib/cart/lineItem';
import { CheckoutStepCompleted, checkoutStepCompleted } from '@/rudder-typer';
import { formatPurchaseItem, gtag } from '@/utils/analytics';
import { formatStandardProductsItem } from '@/utils/analytics/rudderstack';
import { Money } from '@/utils/money';

export interface NutsCheckoutStepCompleted
  extends Omit<CheckoutStepCompleted, 'payment_method' | 'products' | 'total'> {
  readonly checkoutType: string;
  readonly coupon?: string;
  readonly lineItems: NutsLineItem[];
  readonly paymentMethod?: string;
  readonly step: 'address' | 'delivery';
  readonly total: Money;
}

function formatGTagPayload(eventProps: NutsCheckoutStepCompleted) {
  const gtagEvent: Record<string, unknown> = {
    checkout_type: eventProps.checkoutType,
    coupon: eventProps.coupon,
    currency: 'USD',
    items: eventProps.lineItems.map(formatPurchaseItem),
    shipping_tier: eventProps.shipping_option,
    value: dollars(eventProps.total),
  };
  return gtagEvent;
}

function pickCheckoutStepCompleted(eventProps: NutsCheckoutStepCompleted): CheckoutStepCompleted {
  const properties = pick(eventProps, ['checkout_id', 'shipping_option', 'step']);
  return {
    ...properties,
    payment_method: eventProps.paymentMethod,
    products: eventProps.lineItems.map(formatStandardProductsItem),
    total: dollars(eventProps.total),
  };
}

export function sendCheckoutStepCompletedEvent(eventProps: NutsCheckoutStepCompleted) {
  const googleEventObj = formatGTagPayload(eventProps);
  const gtagEventName = eventProps.step === 'delivery' ? 'add_shipping_info' : 'add_address_info';
  gtag('event', gtagEventName, googleEventObj);

  try {
    const payload = pickCheckoutStepCompleted(eventProps);
    checkoutStepCompleted(payload);
  } catch (e) {
    reportError(e);
  }
}
